<template>
<div class="main-wrap">
    <div class="main-containers">
        <my-header></my-header>
            <div class="container" style="margin-top: 60px">
            <h1 style="text-align: center;font-size: 22px;display: table;"></h1>
            <div style="margin-top: 20px;" v-if="type ==3 || type == 10">
                <el-button type="primary" @click="launch" size="mini" style="float: right;margin-left: 20px">提交审核</el-button>
                <el-button type="primary" @click="save(0)" size="mini" style="float: right">保存</el-button>
            </div>
            <div v-else-if="type == 2">
                <el-button type="primary" @click="approve" size="mini" style="float: right;margin-left: 20px">通过</el-button>
                <el-button type="primary" @click="reject" size="mini" style="float: right">驳回</el-button>
            </div>
            <!-- <div style="margin-top: 20px;" v-else-if="sourceType == 2">
                <el-button type="primary" @click="submitSettle" size="mini" style="float: right;margin-left: 20px">提交结算申请</el-button>
            </div> -->
            <div style="margin-top: 20px;" v-else-if="type == 5 || type== 71">
                <el-button type="primary" @click="submitSettle" size="mini" style="float: right;margin-left: 20px">提交付款申请</el-button>
            </div>
            <div style="margin-top: 20px;" v-else-if="type == 7">
                <el-button type="primary" @click="confirmOrder" size="mini" style="float: right;margin-left: 20px">确认订单</el-button>
            </div>
            <div v-if="type == 9" style="margin-top: 10px;">
                <el-button type="primary" @click="dispatchConfirm" size="mini" style="float: right">确认</el-button>
            </div>
            <!-- v-if="smyDeals.bindContract == 0" -->

            <div  v-if="dispatchData.bindContract == 0" style="padding-top: 30px;">
                <h3 class="iconfont iconxiala">合同信息</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form status-icon inline-message :model="dispatchData" inline  label-width="200px" >
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="合同名称：" class="noMarginBottom" required>
                                <!-- <div style="width:100%;display:flex;"> -->
                                <!-- @focus="contractListData" -->
                                <el-input

                                        size="mini"
                                        class="minWidth"
                                        readonly
                                        placeholder="请选择合同">
                                </el-input>
                                <!-- </div> -->
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                            <el-form-item label="预估金额：" required class="noMarginBottom">
                            <el-input v-model="dispatchData.estimatedAmount"
                                size="mini"
                                readonly
                                class="minWidth"/>
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="项目：" class="noMarginBottom">
                                <el-input v-model="dispatchData.projectName"
                                    size="mini"
                                    readonly
                                    class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="供应商名称：" required class="noMarginBottom">
                                <el-input v-model="dispatchData.supplierName"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                            <!-- <el-form-item label="供应商名称：" class="noMarginBottom" required>
                                <el-input v-model.trim="smyDeals.supplierName"
                                        @focus="showContractDialog"
                                        size="mini"
                                        class="minWidth"
                                        readonly
                                        placeholder="请选择供应商">
                                    <i slot="suffix" class="iconfont iconjiansuo"  @click="showContractDialog"></i>
                                </el-input>
                            </el-form-item> -->
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                        <el-form-item label="未绑定合同原因：" class="noMarginBottom maxWidthForm" prop="unboundReason">
                            <el-input
                                type="textarea"
                                :maxlength="500"
                                size="mini"
                                disabled
                                :rows="5"
                                placeholder=""
                                v-model="dispatchData.unboundReason">
                            </el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div style="padding-top: 30px;" v-else>
                <contract ref="contract" :readonly="isReadOnly" @callback="contractSelect"/>
            </div>
            <!-- v-if="dispatchDataFalse" -->
            <!-- type== 9 || type ==3 || type == 10 || type== 5 -->
            <div v-if="dispatchDataFalse" :disabled="true">
                <section class="small-container">
                    <h3 class="iconfont iconxiala">派工单信息</h3>
                    <el-row class="colorLine">
                        <el-col :span="10">
                            <div style="height: 1px;background: #91002c;"></div>
                        </el-col>
                        <el-col :span="14">
                            <div style="height: 1px;background: #003570;"></div>
                        </el-col>
                    </el-row>
                    <el-form style="margin-bottom: 10px;"  label-width="200px" disabled status-icon inline :model="dispatchData" ref="wFlowFormInfo">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="发起人：">
                                    <el-input  size="mini" class="minWidth"  v-model="dispatchData.promoterUserName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系电话：">
                                    <el-input  size="mini" class="minWidth"  v-model="dispatchData.phone"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="工程派工单名称：">
                                    <el-input  size="mini" class="minWidth"  v-model="dispatchData.projectNoticeName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工程类型："  prop="projectNoticeType">
                                    <el-select v-model="dispatchData.projectNoticeType" placeholder="请选择" size="mini" class="minWidth">
                                        <el-option label="零星工程" :value=1>
                                        </el-option>
                                    </el-select>
                                        <!-- <el-input  size="mini" class="minWidth"  v-model="dispatchData.dispatchType" disabled></el-input> -->
                                    </el-form-item>
                                <!-- <el-form-item label="工程类型：">
                                    <el-input  size="mini" class="minWidth"  v-model="dispatchData.dispatchType"></el-input>
                                </el-form-item> -->
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预估金额："  class="noMarginBottom">
                                <el-input v-model.number="dispatchData.estimatedAmount"
                                    size="mini"
                                    class="minWidth"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="改造面积(㎡)："  class="noMarginBottom">
                                <el-input v-model.number="dispatchData.rebuildArea"
                                    size="mini"
                                    class="minWidth"/>
                                </el-form-item>
                            </el-col>
                            </el-row>
                        <el-row>
                            <el-col :span="12" >
                                <el-form-item label="计划开始时间：" prop="" class="noMarginBottom">
                                    <el-date-picker v-model="dispatchData.projectStartTime" size="mini" class="minWidth" :clearable=false align="right" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" >
                                <el-form-item label="计划结束时间：" prop="" class="noMarginBottom">
                                    <el-date-picker v-model="dispatchData.projectEndTime" size="mini" class="minWidth" :clearable=false align="right" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="改造依据：" prop="bidRanges" style="margin-top: 10px;" class="noMarginBottom maxWidthForm">
                                    <el-input type="textarea" size="mini" :rows="5" :maxlength="500" placeholder="请输入内容(最多500字)" v-model="dispatchData.transformationBasis">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="项目现状：" prop="qualityRequiements" class="noMarginBottom maxWidthForm">
                                    <el-input v-model="dispatchData.projectStatus" type="textarea" size="mini" :rows="5" :maxlength="500" placeholder="请输入内容(最多500字)">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="改造内容：" prop="qualityRequiements" class="noMarginBottom maxWidthForm">
                                    <el-input v-model="dispatchData.transformationContent" type="textarea" size="mini" :rows="5" :maxlength="500" placeholder="请输入内容(最多500字)">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="相关措施：" prop="qualityRequiements" class="noMarginBottom maxWidthForm">
                                    <el-input v-model="dispatchData.relevantMeasures" type="textarea" size="mini" :rows="5" :maxlength="500" placeholder="请输入内容(最多500字)">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </section>

            </div>
            <div v-if="dispatchDataFalse">
                <section class="small-container">
                    <h3 class="iconfont iconxiala">派工单附件</h3>
                    <el-row class="colorLine">
                        <el-col :span="10">
                            <div style="height: 1px;background: #91002c;"></div>
                        </el-col>
                        <el-col :span="14">
                            <div style="height: 1px;background: #003570;"></div>
                        </el-col>
                    </el-row>
                </section>
                <el-row>
                    <el-col :span="24">
                        <el-form status-icon inline-message inline label-width="200px"  :model="attachementVOD.otherAttachments">
                            <el-form-item label="附件" class="noMarginBottom attachmentForm">
                                <!-- <div style="width:100%;display:flex;"> -->
                                    <!-- <div style="width:95%;"> -->
                                        <page-upload
                                            @finishUpload="(fileList)=>{this.finishUpload(401, fileList)}"
                                            :editFlag="enclosure"
                                            :files="attachementVOD.otherAttachments"
                                            :attachmentType="401">
                                        </page-upload>
                                    <!-- </div> -->
                                    <!-- <div>
                                        <div v-for="item in attachementVOD.otherAttachments" :key="item" style="margin-top:5px;">
                                            <el-button  v-if="isReadOnly && attachementVOD.otherAttachments.length" type="text" size="mini" @click="preview(401, item.attachPath, item.attachName)">预览</el-button>
                                        </div>
                                    </div> -->
                                <!-- </div> -->
                                    <!-- <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(401, fileList)}"
                                    :files="attachementVOD.otherAttachments"
                                    :editFlag="enclosure"
                                    :attachmentType="401">
                                </page-upload> -->
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            <!-- :buildingArea="buildingArea" :rebuildArea="rebuildArea" -->
            <div style="padding-top: 30px;" v-if="type != 9">
                <order ref="order"  style=""
                    :amountExclTax="amountExclTax" :amountWithTax="amountWithTax"
                    :actualAmountExclTax="actualAmountExclTax" :actualAmountWithTax="actualAmountWithTax"
                    :actualAmountExclTax2="actualAmountExclTax2" :actualAmountWithTax2="actualAmountWithTax2"
                    :actualTaxRatioAmount="actualTaxRatioAmount" :zbjAmountExclTax="zbjAmountExclTax"
                    :readonly="isReadOnly" :isOrderSettle="type" @changeRegional="priceChoosed([])"/>
            </div>
            <div v-if="type != 9">
                <section class="small-container">
                    <h3 v-if="type == 7 || type == 8" class="iconfont iconxiala">订单清单</h3>
                    <h3 v-else class="iconfont iconxiala">编制结算清单</h3>
                    <el-row class="colorLine">
                        <el-col :span="10">
                            <div style="height: 1px;background: #91002c;"></div>
                        </el-col>
                        <el-col :span="14">
                            <div style="height: 1px;background: #003570;"></div>
                        </el-col>
                    </el-row>
                    <div>
                        <div style="padding: 0px 20px;" class="cf">
                            <div style="float: left;">
                                价格库清单
                            </div>
                            <el-button v-if="!isReadOnly" style="float: right; margin-top: -5px; margin-bottom: 5px;" type="primary" size="small" @click="edit(1)">编制</el-button>
                            <span type="primary" class="text-button f14" style="float: right;margin-left: 20px;width: 68px;cursor: pointer;" @click.stop="fileOutput(1)">
                                <i class="iconfont icondaochu"></i> 导出
                            </span>
                            <priceTable ref="priceTable" :editable="!isReadOnly" page="orderAdd" style="margin-top: -20px;" :isOrderSettle="isOrderSettle" :orderStatus="orderStatus" @totalBack="(excl,wit)=>{this.actualAmountExclTax=excl;this.actualAmountWithTax=wit}" :maxHeight="220"></priceTable>
                        </div>
                        <div style="padding: 0px 20px; margin-top: 20px;" v-if="!dispatchDataFalse" class="cf">
                            <div style="display: flex;width:100%;;margin-bottom: 20px;font-size:14px;">
                                <div style="width:90%;">
                                    新增清单<span style="color:red;font-size:12px;">(非库内价格，标*为集采价格库已存在)</span>
                                </div>
                                <div style="width:10%;cursor: pointer;display: flex;text-align: right;margin-right:10px;">
                                    <el-upload
                                        v-if="sourceType == 1"
                                        style="flex:1;"
                                        :action="tempUrlSettlement"
                                        :show-file-list="false"
                                        :multiple="false"
                                        :http-request="beforeFileInput"
                                        :on-error="uploadErr"
                                        :on-success="uploadSuc">
                                        <span v-if="this.type!=1" type="primary"  style="cursor: pointer;">
                                            <i class="iconfont icondaoru2"></i> 导入
                                        </span>
                                    </el-upload>
                                    <!-- <el-upload
                                        v-else
                                        style="flex:1;"
                                        :action="tempUrl"
                                        :show-file-list="false"
                                        :multiple="false"
                                        :http-request="beforeFileInput"
                                        :on-error="uploadErr"
                                        :on-success="uploadSuc">
                                        <span v-if="this.type!=1" type="primary"  style="cursor: pointer;">
                                            <i class="iconfont icondaoru2"></i> 导入
                                        </span>
                                    </el-upload> -->
                                    <div style="cursor: pointer;flex:1;" @click.stop="fileOutput(2)">
                                        <i class="iconfont icondaochu"></i> 导出
                                    </div>
                                    <!-- <span v-if="this.type!=1" type="primary" class="text-button f14" style="cursor: pointer;" @click.stop="fileOutput(2)">
                                        <i class="iconfont icon-xiazaizhongxin"></i> 导出
                                    </span> -->
                                </div>
                            </div>
                            <div class="marg-top-cls">
                                <priceTable v-if="isReadOnly" :readonly="isReadOnly" page="orderAdd" ref="priceTableInput" style="margin-top: -20px;" :isOrderSettle="isOrderSettle" :orderStatus="orderStatus" @totalBack="(excl,wit)=>{debugger;this.actualAmountExclTax=excl;this.actualAmountWithTax=wit}" :maxHeight="220"></priceTable>
                                <priceTableInput v-if="!isReadOnly" :readonly="isReadOnly" page="settle" ref="priceTableInput" style="margin-top: -20px;" :isOrderSettle="isOrderSettle" :orderStatus="orderStatus" @callback="listChanged" :maxHeight="220"></priceTableInput>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="small-container" v-if="sourceType == 2">
                    <h3 class="iconfont iconxiala">备注</h3>
                    <el-row class="colorLine">
                        <el-col :span="10">
                            <div style="height: 1px;background: #91002c;"></div>
                        </el-col>
                        <el-col :span="14">
                            <div style="height: 1px;background: #003570;"></div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px" :disabled="isReadOnly">
                                <el-form-item label="备注：" class="noMarginBottom maxWidthForm">
                                    <el-input
                                        type="textarea"
                                        :maxlength="500"
                                        size="mini"
                                        :rows="5"
                                        placeholder="请输入内容"
                                        v-model="remark"
                                    >
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </section>
                <section class="small-container">
                    <h3 class="iconfont iconxiala">附件</h3>
                    <el-row class="colorLine">
                        <el-col :span="10">
                            <div style="height: 1px;background: #91002c;"></div>
                        </el-col>
                        <el-col :span="14">
                            <div style="height: 1px;background: #003570;"></div>
                        </el-col>
                    </el-row>
                     <el-row>
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px" v-if="dispatchDataFalse">
                                <el-form-item label="工程维修：" class="noMarginBottom attachmentForm">
                                        <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(226, fileList)}"
                                        :files="attachments.engineering"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="226">
                                    </page-upload>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px" v-if="dispatchDataFalse">
                                <el-form-item label="方案及图纸：" class="noMarginBottom attachmentForm">
                                    <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(227, fileList)}"
                                        :files="attachments.programme"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="227">
                                    </page-upload>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px" v-if="dispatchDataFalse">
                                <el-form-item label="验收证明：" class="noMarginBottom attachmentForm">
                                    <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(228, fileList)}"
                                        :files="attachments.acceptance"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="228">
                                    </page-upload>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px" v-if="dispatchDataFalse">
                                <el-form-item label="现场施工(前)：" class="noMarginBottom attachmentForm">
                                    <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(229, fileList)}"
                                        :files="attachments.beforeConstruction"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="229">
                                    </page-upload>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px" v-if="dispatchDataFalse">
                                <el-form-item label="现场施工(后)：" class="noMarginBottom attachmentForm">
                                    <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(230, fileList)}"
                                        :files="attachments.afterConstruction"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="230">
                                    </page-upload>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row >
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px"  v-if="dispatchDataFalse">
                                <el-form-item label="其他附件：" class="noMarginBottom attachmentForm">
                                    <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(91, fileList)}"
                                        :files="attachments.enclosure"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="91">
                                    </page-upload>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row v-if="sourceType == 2">
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px">
                                <el-form-item label="附件：" class="noMarginBottom attachmentForm" >
                                    <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(91, fileList)}"
                                        :files="attachmentVOSother"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="91">
                                    </page-upload>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px" v-if="(type == 5 && order.sourceType == 2) || type == 7">
                                <el-form-item label="回传附件：" class="noMarginBottom attachmentForm">
                                    <page-upload
                                        :files="returnAttachment"
                                        :editFlag="!isReadOnlys"
                                        :attachmentType="94">
                                    </page-upload>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </section>
                <section class="small-container" v-if="type == 3 && reviewComments != ''">
                    <h3 class="iconfont iconxiala">审核意见</h3>
                    <el-row class="colorLine">
                        <el-col :span="10">
                            <div style="height: 1px;background: #91002c;"></div>
                        </el-col>
                        <el-col :span="14">
                            <div style="height: 1px;background: #003570;"></div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form status-icon inline-message inline label-width="200px" disabled>
                                <el-form-item label="审核意见：" class="noMarginBottom maxWidthForm">
                                    <el-input
                                        type="textarea"
                                        :maxlength="500"
                                        size="mini"
                                        :rows="5"
                                        placeholder="请输入内容"
                                        v-model="reviewComments">
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </section>
                <!-- <div v-if="type !=5 || type !=7 || type !=8">
                    <section class="small-container" v-if="aa">
                        <h3 class="iconfont iconxiala">审核意见</h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form status-icon inline-message :model="smyDeals" inline disabled label-width="200px" :rules="formRules">
                            <el-form-item label="审核意见：" class="noMarginBottom maxWidthForm" >
                                <el-input
                                    type="textarea"
                                    :maxlength="500"
                                    size="mini"
                                    :rows="5"
                                    placeholder=""
                                    v-model="smyDeals.remarks">
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </section>
                </div> -->

            </div>
            <priceChooseDialog ref="priceChooseDialog" @callback="priceChoosed"></priceChooseDialog>

            <el-dialog title="是否入价格库" width="500px" top="10vh" :visible.sync="dialogFlag"
                    :close-on-click-modal="$root.dialogAutoClose" :close-on-press-escape="$root.dialogAutoClose">
                <el-form :inline="true" :model="form" :rules="formRules" ref="priceForm">
                    <el-form-item label="新增清单是否入价格库：">
                        <el-radio-group v-model="form.storeFlag">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFlag = false">取 消</el-button>
                    <el-button type="primary" @click="confirm">保 存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</div>

</template>

<script>
    import util from '@/util/'
    import MyHeader from '../common/Header.vue'
    import Contract from "./components/contract";
    import Order from "./components/order";
    import jiesuan from "./components/jiesuan";
    import priceTable from '../order/components/priceTable';
    import priceTableInput from '../order/components/priceTableInput';
    export default {
        name: "order-add",
        components: {
            Contract,
            Order,
            jiesuan,
            priceTable,
            priceTableInput,
            MyHeader,
        },
        computed: {
            isReadOnly(){
                if(this.type == 1 || this.type == 2 || this.type == 5 || this.type == 6 || this.type == 8 || this.type == 7|| this.type == 71){
                    return true;
                }else {
                    return false;
                }
            },
            isReadOnlys(){
                if(this.type == 7 || this.type == 5){
                    return false;
                }else {
                    return true;
                }
            },
            // 派工单附件
            enclosure(){
                if (this.type == 3 || this.type == 9 || this.type == 10 || this.type == 1 || this.type == 5){
                    return false
                } else{
                     return true;
                }
            },
            isOrderSettle() {
                // console.log('111111',this.type)
                // sourceType 2 内网
                if (this.type == 5  && this.sourceType == 2) {
                    return this.type;
                } else if(this.type == 6) {
                    return this.type;
                } else if(this.type == 7) {
                    return this.type;
                } else if(this.type == 8) {
                    return this.type;
                }  else if(this.type == 71) {
                    return this.type;
                } else {
                    return null;
                }
            },
            orderStatus() {
                if (this.orderStatusType == 0) {
                    return this.orderStatusType
                } else if (this.orderStatusType == 3){
                    return this.orderStatusType
                }else {
                    return null;
                }
            },
            amountExclTax(){
                let sum = 0;
                // console.log('777777',this.choosedPriceList)
                let tempTableData = [...this.addedPriceList, ...this.choosedPriceList];

                tempTableData.forEach(item => {
                    // if(item.quotationType == 1) {
                        // 原始乘法
                        // let temp = this.$root.accMul(item.unitAmountExclTax, item.quantities)
                        // console.log(this.accMul(item.unitAmountWithTax , item.quantities))
                        let add = this.mathDiv(this.accMul(item.unitAmountWithTax , item.quantities), (1 + this.mathDiv(item.taxRatio, 100)))
                        sum = Number(sum + add)

                        // let temp = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                        // sum = this.$root.accAdd(sum, temp);
                        // console.log(sum,'sum')

                    // }
                });
                return sum.toFixed(2);
                // return sum
            },
            // buildingArea(){
            //     let add = this.mathDiv(this.amountWithTax,this.buildingArea)
            //     return add
            // },
            //结算总额(不含税)
            // amountExclTax(){
            //     let sum = 0;
            //     let tempTableData = [...this.addedPriceList, ...this.choosedPriceList];
            //     console.log('11111111111',tempTableData)
            //     tempTableData.forEach(item => {
            //         if(item.quotationType == 1) {
            //             // 原始乘法
            //             // let temp = this.$root.accMul(item.unitAmountExclTax, item.quantities)
            //             // console.log(this.accMul(item.unitAmountWithTax , item.quantities))
            //             let add = this.mathDiv(this.accMul(item.unitAmountWithTax , item.quantities), (1 + this.mathDiv(item.taxRatio, 100)))
            //             // console.log('11111',add)
            //             sum = Number(sum + add)
            //             // sum = this.$root.accAdd(sum, add)
            //             // console.log(sum.toFixed(2))
            //             }
            //     });
            //     // console.log(tempTableData,'1')
            //     // tempTableData.forEach(item => {
            //     //     if(item.quotationType == 1) {
            //     //         let temp = this.$root.accMul(item.unitAmountExclTax, item.quantities);
            //     //         sum = this.$root.accAdd(sum, temp);
            //     //     }
            //     // });
            //     return sum
            // },
            //结算总额(含税)
            amountWithTax(){
                let sum = 0;
                let tempTableData = [...this.addedPriceList, ...this.choosedPriceList];
                // console.log(tempTableData,'2')
                tempTableData.forEach(item => {
                    // if(item.quotationType == 1){
                        let temp = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                        sum = this.$root.accAdd(sum, temp);
                    // }
                });
                return sum;
            },

            //质保金不含税
            zbjAmountExclTax(){
                let sum = 0;
                // let tempTableData = this.amountExclTax
                // sum = tempTableData - (tempTableData*0.05)
                // sum = tempTableData - (tempTableData*5)
                // tempTableData.forEach(item => {
                //     if(item.quotationType == 1){
                //         let temp = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                //         sum = this.$root.accAdd(sum, temp);
                //     }
                // });
                return sum;
            },
            //实际结算总额(不含税)
            actualAmountExclTax () {
                let sum = 0;
                let tempTableData = [...this.addedPriceList, ...this.choosedPriceList];

                tempTableData.forEach(item => {
                    // console.log(item)
                    if(item.quotationType == 1){
                        // let temp = this.mathDiv(this.accMul(item.unitAmountWithTax , item.actualQuantities), (1 + this.mathDiv(item.taxRatio, 100)))
                        let temp = this.$root.accMul(item.actualQuantities, item.unitAmountExclTax);
                        sum = this.$root.accAdd(sum, temp);
                        // sum = Number(sum + temp)
                    }
                });
                if (this.zbjProportion) {
                    sum = sum-(sum * (this.zbjProportion / 100))
                }
                return sum;
            },
            //实际结算总额(含税)
            actualAmountWithTax () {
                let sum = 0;
                let tempTableData = [...this.addedPriceList, ...this.choosedPriceList];
                // console.log(tempTableData)
                tempTableData.forEach(item => {
                    if(item.quotationType == 1){
                        let temp = this.$root.accMul(item.actualQuantities, item.unitAmountWithTax);
                        sum = this.$root.accAdd(sum, temp);
                    }
                });
                if (this.zbjProportion) {
                    sum = sum-(sum * (this.zbjProportion / 100))
                }
                return sum;
            },
             // 质保金(含税)
            actualTaxRatioAmount(){
                let sum = 0;
                sum = this.actualAmountWithTax - this.actualAmountExclTax
                // let tempTableData = this.amountWithTax
                // sum = tempTableData - (tempTableData*0.05)
                return sum;
            },
        },
        created() {
            // console.log(this.type,'this.type')
            // console.log(this.id,'id')
            // this.getOrderDetail()
            if (this.type == 9 || this.type == 3) {
                this.getProjectNoticeDetail()
            } else {
                this.getOrderDetail()
            }

        },
        data(){
            return{
                tempUrl: this.$root.baseUrl + "/v1/sOrders/public/importOrder", // 订单导入
                tempUrlSettlement: this.$root.baseUrl + "/v1/sProjectNotice/public/importProjectNotice", // 结算导入
                smyDeals: {
                    unboundReason: '',
                    bindContract: '',
                    projectId: '',
                    supplierName: '',
                    estimatedAmount: '',
                },
                open: false,
                orderId: '',
                dispatchData: {
                    promoterUserName: '',
                    phone: '',
                    projectNoticeName: '',
                    projectNoticeType: '',
                    // dispatchType: '',
                    startTime: '',
                    endTime: '',
                    transformationBasis: '',
                    projectStatus: '',
                    transformationContent: '',
                    relevantMeasures: '',
                    projectEndTime: '',
                    projectStartTime: '',
                },
                attachments: {
                    dispatchList: []
                },
                attachmentVOSother: [],
                dispatchDataFalse: false,
                orderStatusType: '',
                companyId: '',
                zbjProportion: '',
                fileList: [],
                aa: false,
                type: this.$route.params.type ? this.$route.params.type : '4',//类型 1： 详情  2: 审批 3：编辑 4：新建 5：提交验收申请 6：查看验收申请
                id: this.$route.params.id,
                choosedPriceList: [],
                addedPriceList: [],

                remark: '',
                reviewComments: '',// 审核意见
                outMapAttachmentVOs: {}, //附件清单
                attachments: {
                    enclosure: [],
                    engineering: [],
                    programme: [],
                    acceptance: [],
                    beforeConstruction: [],
                    afterConstruction: [],
                    dispatchList: [], // 派工单附件
                },
                attachementVOD: {
                    otherAttachments: []
                },
                // attachments: [],
                returnAttachment: [],

                order: {},

                dialogFlag: false,
                form: {
                    storeFlag: 1,
                    effectStartTime: '',
                    effectEndTime: '',
                },
                formRules: {
                    effectStartTime: [
                        {required: true, message: '请选择报价有效开始时间', trigger: 'blur'},
                    ],
                    effectEndTime: [
                        {required: true, message: '请选择报价有效截止时间', trigger: 'blur'},
                    ],
                },
                // actualAmountWithTax:'',
                // actualAmountExclTax:'',
                actualAmountWithTax2:'',
                actualAmountExclTax2:'',
                categoryId:'',
                category: {},
                sourceType:'',
            }
        },
        methods:{
            // 导出
            fileOutput(data) {
                if (data == 1){
                    let url =
                    util.baseUrl +
                    "/v1/sProjectNotice/public/exportProjectNotice?listType=1&orderId=" + this.orderId
                    window.location.href = url
                } else {
                    let url =
                    util.baseUrl +
                    "/v1/sProjectNotice/public/exportProjectNotice?listType=2&orderId=" + this.orderId
                    window.location.href = url
                }
            },
            // 上传成功
            uploadSuc(res, f, fs) {
                // console.log(res,'12345')
                if (res.code === "1") {
                    let that = this;
                    this.$alert(res.msg, {
                    type: "success",
                    callback: () => {
                        this.getOrderDetail()
                        // if (this.type == 9 || this.type == 3) {
                        //     this.getProjectNoticeDetail()
                        // } else {
                        //     this.getOrderDetail()
                        // }
                    }
                    });
                } else this.$alert("文件导入失败！", { type: "error" });
            },
            // 上传失败
            uploadErr() {
                this.$alert("导入失败！");
            },
            beforeFileInput(param) {
                this.saveBC(0)
                setTimeout(()=>{
                    this.fileInput(param, () => {
                        this.getOrderDetail()
                        // if (this.type == 9 || this.type == 3) {
                        //     this.getProjectNoticeDetail()
                        // } else {
                        //     this.getOrderDetail()
                        // }
                    })
                },1500)
            },
            saveBC(saveFlag){
                let that = this;

                let priceTableRef = this.$refs['priceTable'];
                let priceTableInputRef = this.$refs['priceTableInput'];
                this.choosedPriceList = this.choosedPriceList.map(item => {
                    delete item.id;
                    item.listType = 1;
                    if (saveFlag != 0) {
                        if (item.dealListStatus == 2) {
                            item.dealListStatus = 3
                            // item.dealListRemarks = ''
                        }
                    } else {
                        if (item.dealListStatus == 1) {
                            item.dealListStatus = item.dealListStatus
                        }
                    }

                    if(item.quotationType == 1) {
                        item.amountExclTax = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                        item.amountWithTax = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                    }
                    return item;

                })

                this.addedPriceList = this.addedPriceList.map(item => {
                    item.listType = 2;
                    if (saveFlag != 0) {
                        if (item.dealListStatus == 2) {
                            item.dealListStatus = 3
                            // item.dealListRemarks = ''
                        }
                    } else {
                        if (item.dealListStatus == 1) {
                            item.dealListStatus = item.dealListStatus
                        }
                    }
                    if(item.quotationType == 1) {
                        // item.unitAmountExclTax = this.$root.accMul(this.$root.accDiv(item.unitAmountWithTax, this.$root.accAdd(this.$root.accDiv(item.taxRatio, 100),1)), item.quantities)
                        item.amountExclTax = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                        item.amountWithTax = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                    }
                    return item;
                })
                // if (saveFlag == 0) {
                //     this.choosedPriceList.map(item => {
                //         this.$set(item,'dealListStatus', '')
                //     })
                // }

                let formParams = {
                    storeDetails: this.choosedPriceList,
                    newDetails: this.addedPriceList,
                    outMapAttachmentVOs: {},
                    backAttachmentVOS: this.returnAttachment,
                    remarks: this.remark,
                    saveFlag: saveFlag,
                    type: this.type,
                    extSProjectNotice: this.dispatchData,
                    id: this.orderId
                    // id: this.id
                };
                for(let key in this.outMapAttachmentVOs){
                    formParams.outMapAttachmentVOs[key] = this.outMapAttachmentVOs[key].fileList;
                }
                // console.log(formParams)
                // 驳回之后重新上传赋值只是当前的文件
                // formParams.outMapAttachmentVOs ={}
                // // console.log(this.outMapAttachmentVOs)
                // for (let key in this.outMapAttachmentVOs) {
                //     console.log(key)
                //     formParams.outMapAttachmentVOs[key] = this.outMapAttachmentVOs[key].fileList;
                // }
                let contractRef = this.$refs['contract'];
                // console.log('合同123',contractRef)
                if (contractRef) {
                        if(contractRef.contract){
                        formParams.contractId = contractRef.contract.id;
                        formParams.companyId = contractRef.contract.companyId
                    }
                        // formParams.contractId = null
                        // formParams.companyId = null
                } else {
                    formParams.contractId = null
                    formParams.companyId = null
                }

                // formParams.contractId = null
                // formParams.companyId = null
                let orderRef = this.$refs['order']
                // console.log(orderRef,'12345')
                if(orderRef){
                    formParams = Object.assign({}, orderRef.order,formParams);
                    formParams.saveFlag = saveFlag;
                }
                this.dispatchData.rebuildArea = orderRef.order.rebuildArea
                formParams.categoryId = this.categoryId

                this.$root.postHttp('/v1/outerformflowHS/approveContractForJS',formParams,function(res){
                    // that.$alert(saveFlag == 1 ? '提交成功' : '保存成功', '提示', {
                    //     confirmButtonText: '确定',
                    //     type: 'success',
                    //     callback: action => {
                    //         window.close();
                    //         fn(true)
                    //     }
                    // });
                })
            },
            fileInput(param, fn) {
                let that = this;
                let orderId = ''
                if (this.orderId){
                    orderId = this.orderId
                }
                let formData = new FormData();
                formData.append("listType", "2");
                formData.append("orderId", orderId);
                // formData.append("taxRatioMethod", this.wFlowFormInfo.taxRatioMethod);
                // formData.append("type", "");
                formData.append("file", param.file);
                // formData.append("buy", 1);
                that.$root.postFunc(
                    "/v1/sProjectNotice/public/importProjectNotice",
                    formData,
                    function(res) {
                        console.log(res,'22222')
                    if (res.data.code === "1") {
                        that.$alert(res.data.msg, {
                        type: "success",
                        callback: () => {
                            fn();
                        }
                        });
                    }
                    }
                );
            },
            // 除法
            mathDiv(arg1, arg2) {
                arg1 = arg1 || 0;
                arg2 = arg2 || 0;
                // num = num || 2
                var t1 = 0,
                    t2 = 0,
                    r1, r2;
                try {
                    t1 = arg1.toString().split(".")[1].length
                } catch (e) {}
                try {
                    t2 = arg2.toString().split(".")[1].length
                } catch (e) {}
                r1 = Number(arg1.toString().replace(".", ""));
                r2 = Number(arg2.toString().replace(".", ""));
                let result = Number((r1 / r2) * Math.pow(10, t2 - t1))
                return result
            },
            // 乘法
            accMul(arg1, arg2) {
                arg1 = arg1 || 0;
                arg2 = arg2 || 0;
                // num = num || 2
                var m = 0,
                    s1 = arg1.toString(),
                    s2 = arg2.toString();

                try {
                    m += s1.split(".")[1].length
                } catch (e) {}

                try {
                    m += s2.split(".")[1].length
                } catch (e) {}
                let result = Number((Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)))
                return result;

            },
            // 确认订单
            confirmOrder () {
                // let that = this;
                // this.checkForm().then((res)=>{
                //     if(Array.isArray(res)){
                //         if(this.choosedPriceList.length == 0){
                //             this.$alert('请先选择价格库清单',{
                //                 type: 'warning'
                //             });
                //             return;
                //         }
                //         this.save(1, (result)=>{
                //             if(result){
                //             }
                //         });
                //     }else {
                //         this.$alert(res,{
                //             type: 'warning'
                //         });
                //     }
                // }).catch(e=>{
                //     console.log(e);
                // });
                 this.$confirm('确定确认订单吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            this.save(0, (result)=>{
                                if(result){
                                }
                            });
                            this.$router.push('/gateway/index');
                            // this.$root.postHttp('/v1/sOrders/confirmOrder',{orderId: this.id,},res =>{
                            //     console.log(res)
                            //     this.$alert('提交成功', {
                            //         confirmButtonText: '确定',
                            //         type: 'success',
                            //         callback: action => {

                            //         }
                            //     })
                            //     this.$router.push('/gateway/index');
                            // })
                        }else {
                            this.$alert(res,{
                                type: 'warning'
                            });
                    }
                    }
                });


            },
            // 取消订单
            cancelOrder () {
                this.$router.push('/gateway/index');
            },
            // 结算编辑详情
            getOrderDetail () {
                var that = this;
                if(this.id){
                    this.$root.getHttp('/v1/sOrders/getOrderDetail/'+ this.id, res =>{

                        that.orderId = res.data.data.id
                        that.order = res.data.data
                        if (res.data.data.extSProjectNotice) {
                            that.dispatchDataFalse = true
                            that.dispatchData = res.data.data.extSProjectNotice
                            // that.smyDeals = res.data.data.extSProjectNotice
                            that.attachementVOD.otherAttachments = res.data.data.extSProjectNotice.mapAttachments[401] || []
                            that.smyDeals.bindContract = res.data.data.extSProjectNotice.bindContract
                            if (that.smyDeals.bindContract == 0){
                                this.open = true
                                that.smyDeals = res.data.data.extSProjectNotice
                                // that.smyDeals.estimatedAmount = res.data.data.extSProjectNotice.estimatedAmount
                                that.smyDeals.supplierName =  res.data.data.extSProjectNotice.supplierName
                                that.smyDeals.unboundReason = res.data.data.extSProjectNotice.unboundReason
                                that.smyDeals.projectName = res.data.data.extSProjectNotice.projectName
                            } else {
                                let contractRef = that.$refs['contract'];
                                // console.log(contractRef,'合同12345')
                                if(contractRef.contract){
                                    contractRef.contract = res.data.data.scontact;
                                    contractRef.setData(contractRef.contract)
                                }
                            }
                        } else {
                            that.dispatchDataFalse = false
                            let contractRef = that.$refs['contract'];
                            // console.log(contractRef,'合同123')
                            if(contractRef.contract){
                                contractRef.contract = res.data.data.scontact;
                                contractRef.setData(contractRef.contract)
                            }
                        }
                        // if (res.data.data.)
                        // setTimeout(()=>{
                        //     let contractRef = that.$refs['contract'];
                        //     console.log(contractRef,'合同123')
                        //     if(contractRef){
                        //         contractRef.contract = res.data.scontact;
                        //         contractRef.setData(contractRef.contract)
                        //     }
                        // })

                        // that.$nextTick(()=>{

                        // })
                        // let contractRef = that.$refs['contract'];
                        // console.log(contractRef,'合同信息')
                        // if(contractRef){
                        //     contractRef.contract = res.data.data.scontact;
                        //     contractRef.setData(contractRef.contract)
                        // }
                        // console.log('结算合同',contractRef.contract)
                        that.orderStatusType = res.data.data.orderStatus
                        if (that.orderStatusType.dispatchType == 1) {

                        }
                        that.categoryId = res.data.data.categoryId


                        that.sourceType = res.data.data.sourceType
                        // console.log(that.$refs['order'])
                        let orderRef = that.$refs['order']
                        // console.log(orderRef,'orderRef')
                        if(orderRef){
                            // that.$nextTick(()=>{
                                if (res.data.data.isZbj) {
                                    that.$refs.order.isZbj= res.data.data.isZbj
                                    that.zbjProportion = res.data.data.zbjProportion
                                } else {
                                    that.$refs.order.isZbj= 0
                                }
                                orderRef.order = res.data.data
                                orderRef.setData(orderRef.order,that.dispatchData.rebuildArea)
                                // console.log('3322',that.$refs.order.buildingAreaM2)
                        }

                        that.remark = res.data.data.remarks;
                        if (res.data.data.smyDeals) {
                            that.reviewComments = res.data.data.smyDeals.remarks
                        }
                        if (res.data.data.attachmentVOS) {
                            that.attachments = res.data.data.attachmentVOS;
                        }
                        for(let key in res.data.data.outMapAttachmentVOs){
                            if(!that.outMapAttachmentVOs[key]){
                                that.outMapAttachmentVOs[key] = {}
                            }
                            that.outMapAttachmentVOs[key].fileList = res.data.data.outMapAttachmentVOs[key] || [];
                        }
                        // that.outMapAttachmentVOs = res.data.data.outMapAttachmentVOs
                        that.attachmentVOSother = res.data.data.attachmentVOS || []
                        that.attachments.enclosure = res.data.data.outMapAttachmentVOs[91] || []
                        that.attachments.engineering = res.data.data.outMapAttachmentVOs[226] || []
                        that.attachments.programme = res.data.data.outMapAttachmentVOs[227] || []
                        that.attachments.acceptance = res.data.data.outMapAttachmentVOs[228] || []
                        that.attachments.beforeConstruction = res.data.data.outMapAttachmentVOs[229] || []
                        that.attachments.afterConstruction = res.data.data.outMapAttachmentVOs[230] || []
                        if (res.data.data.backAttachmentVOS) {
                            that.returnAttachment = res.data.data.backAttachmentVOS;
                        }
                        // console.log(that.attachments)
                        that.sourceType = res.data.data.sourceType;
                        if (res.data.data.smyDeals) {
                            that.smyDeals= res.data.data.smyDeals
                            that.aa = true
                        }
                        // 判断没有价格库清单只有新增清单
                        if (that.order.categoryId) {
                            that.getCategoryInfo(that.order.categoryId, (data)=>{
                                let priceTableRef = that.$refs['priceTable'];
                                data.categoryId = data.id;
                                data.parentCategoryCode = data.grandParentCategoryCode;

                                that.categoryId = data.id;
                                that.category = data;
                                if(priceTableRef){
                                    // console.log('xuyang',priceTableRef)
                                    data.parentCategoryCode = data.grandParentCategoryCode;
                                    that.choosedPriceList = res.data.data.storeDetails

                                    priceTableRef.setData(res.data.data.storeDetails, data);
                                }
                                // that.choosedPriceList = res.data.data.storeDetails ||[];
                                // console.log('11111111111',that.choosedPriceList)
                                let priceTableInputRef = that.$refs['priceTableInput'];
                                if(priceTableInputRef){
                                    that.addedPriceList = res.data.data.newDetails||[];
                                    that.addedPriceList.map(item=>{
                                        let taxRatioAmount = that.$root.accMinus(item.amountWithTax,item.amountExclTax);
                                        item.taxRatioAmount = taxRatioAmount;
                                    })
                                    // console.log('222222',that.addedPriceList)
                                    priceTableInputRef.setData(that.addedPriceList, data);
                                }
                            })
                        } else {
                            let priceTableInputRef = that.$refs['priceTableInput'];
                            // console.log('111111111',priceTableInputRef)
                                if(priceTableInputRef){
                                    that.addedPriceList = res.data.data.newDetails||[];

                                    that.addedPriceList.map(item=>{
                                        let taxRatioAmount = that.$root.accMinus(item.amountWithTax,item.amountExclTax);
                                        item.taxRatioAmount = taxRatioAmount;
                                    })

                                    priceTableInputRef.setData(that.addedPriceList, 201001);
                                    console.log(that.addedPriceList)
                                }
                        }

                    },function(){
                        fn(false);
                    })
                }
            },
            // 派工单详情
            getProjectNoticeDetail (){
                // console.log(this.category,'对象')
                this.$root.getFunc("/v1/sProjectNotice/getProjectNoticeDetail/" + this.id, res => {
                    // console.log(res.data.data)
                    // if (res.data.data.extSProjectNotice) {
                    //         this.dispatchData = res.data.data.extSProjectNotice
                    //         console.log('111派工单',this.dispatchData)
                    //         this.attachementVOD.otherAttachments = res.data.data.extSProjectNotice.mapAttachments[401] || []
                    //     }
                    this.dispatchData = res.data.data
                    this.smyDeals = res.data.data
                    if (res.data.data.attachmentVOS) {
                        this.attachementVOD.otherAttachments = res.data.data.attachmentVOS || []
                        // this.attachments.dispatchList = res.data.data.attachmentVOS
                    }
                    this.dispatchDataFalse = true
                    // console.log('111派工单',this.dispatchData)

                    let contractRef = this.$refs['contract'];
                    if(contractRef){
                        contractRef.contract = res.data.data.scontact
                        contractRef.setData(contractRef.contract)
                    }
                    this.$nextTick(()=>{
                        let orderRef = this.$refs['order']
                        // console.log(orderRef,'789')
                        if (orderRef) {
                            orderRef.order.rebuildArea = this.dispatchData.rebuildArea
                        }
                    })
                    this.sourceType = res.data.data.sourceType
                    // orderRef.setData(this.dispatchData.rebuildArea)

                    if (this.dispatchData.projectNoticeType == 1) {
                        this.dispatchData.dispatchType = '零星工程'
                    }
                })
            },
            // 派工单确认
            dispatchConfirm (){
                this.$root.postHttp("/v1/outerformflowHS/confirmProjectNotice",{projectNoticeId: this.id}, res => {
                    this.$alert('提交成功', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            window.close()
                        }
                    })
                    this.$router.push('/order/list');
                })
            },
            //上传
            finishUpload(fileType, fileList, contactForm){
                console.log(fileType,fileList)
                if (contactForm){}
                else {
                    this.outMapAttachmentVOs[fileType] = fileList;
                    // this.attachments.[fileType] = fileList

                }
            },
            // 确定
            confirm(){
                let that = this;
                let form = that.$refs['priceForm'];
                if(Array.isArray(that.$refs['priceForm'])){
                    form = that.$refs['priceForm'][0]
                }
                form.validate((valid) => {
                    if(valid){
                        let formParams = {
                            dealId: this.$route.query.dealId,
                            orderId: this.id,
                            actionType: 2,
                            storeFlag: this.form.storeFlag,
                            // effectStartTime: this.form.effectStartTime,
                            // effectEndTime: this.form.effectEndTime
                        };
                        this.$root.postHttp('/v1/sOrders/approve',formParams,function(res){
                            that.$alert('提交成功', {
                                confirmButtonText: '确定',
                                type: 'success',
                                callback: action => {

                                }
                            });
                            that.dialogFlag = true;
                            that.$router.push('/order/list');
                        })
                    } else {
                        this.$alert('请先填写必填信息',{
                            type: 'warning'
                        });
                        return;
                    }
                });
            },
            approve(){
                this.dialogFlag = true;
            },
            reject(){
                let that = this;
                let formParams = {
                    dealId: this.$route.query.dealId,
                    orderId: this.id,
                    actionType: 3,
                    storeFlag: 0
                };
                this.$root.postHttp('/v1/sOrders/approve',formParams,function(res){
                    that.$alert('提交成功', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {

                        }
                    });
                },function(){
                })
            },
            listChanged(){
                let priceTableInputRef = this.$refs['priceTableInput'];
                this.addedPriceList = priceTableInputRef.getData();
                let orderRef = this.$refs['order'];
                let datas = {}
                datas.storeDetails = this.choosedPriceList
                datas.newDetails = this.addedPriceList
                if (orderRef){
                    orderRef.setData(datas)
                }
            },
            priceChoosed(val){
                if(val == null && val.length == 0){
                    console.error('pricechoosed back is null')
                    return
                }
                let that = this
                that.choosedPriceList = [...val];
                // console.log('33333333',that.choosedPriceList)
                let priceTableRef = this.$refs['priceTable'];
                let priceTableInputRef = this.$refs['priceTableInput'];
                let orderRef = this.$refs['order'];
                if (that.categoryId != val[0].categoryId) {
                    that.categoryId = val[0].categoryId;
                    that.getCategoryInfo(that.categoryId, (data)=> {
                        data.categoryId = data.id;
                        data.parentCategoryCode = data.grandParentCategoryCode;
                        data.categoryName = data.categoryName;
                        that.categoryId = data.id;
                        that.category = data;
                        if(priceTableRef){
                            priceTableRef.setData(that.choosedPriceList, data);
                        }
                        if (priceTableInputRef) {
                            that.addedPriceList = []
                            priceTableInputRef.setData(that.addedPriceList, data);
                        }
                        let datas = {}
                        datas.storeDetails = this.choosedPriceList
                        datas.newDetails = this.addedPriceList
                        if (orderRef){
                            orderRef.setData(datas)
                        }
                    })
                } else {
                    that.getCategoryInfo(that.categoryId, (data)=> {
                        data.categoryId = data.id;
                        data.parentCategoryCode = data.grandParentCategoryCode;
                        data.categoryName = data.categoryName;
                        that.categoryId = data.id;
                        that.category = data;

                        if(priceTableRef){
                            priceTableRef.setData(this.choosedPriceList, data);
                        }
                        let datas = {}
                        datas.storeDetails = this.choosedPriceList
                        datas.newDetails = this.addedPriceList
                        if (orderRef){
                            orderRef.setData(datas)
                        }
                    })
                }
            },
            contractSelect(){
                debugger
                let contractRef = this.$refs['contract'];
                let orderRef = this.$refs['order'];
                if(orderRef && contractRef){
                    this.getCategory(contractRef.contract.parentCategoryId, (data)=>{
                        let category = data.filter(item => {
                            return item.id == contractRef.contract.categoryId;
                        })[0];

                        let priceTableInputRef = this.$refs['priceTableInput'];
                        if(priceTableInputRef){
                            priceTableInputRef.setData(this.addedPriceList, category);
                        }
                    })
                }
                this.priceChoosed([]);
                orderRef.cleanForm();
            },
            getCategoryInfo(id,fn){
                if (id) {
                    let that = this;
                    that.$root.getHttp('/v1/sSuppliersCategory/getCategoryInfo/'+id, function (res) {
                        fn && fn(res.data.data);
                    })
                }
            },
            getCategory(categoryId='', fn){
                let that = this;
                that.$root.postHttp('/v1/sSuppliersCategory/public/findSuppliersCategoryListByParent', {'categoryId': categoryId}, function (res) {
                    fn && fn(res.data.data);
                })
            },
            checkForm(){
                // debugger
                let checkPromise = [];
                let contractRef = this.$refs['contract'];
                if(contractRef){
                    checkPromise.push(contractRef.submitFormPromise('contract'));
                }
                let orderRef = this.$refs['order'];
                if(orderRef){
                    checkPromise.push(orderRef.submitFormPromise('order'));
                }
                let priceTableRef = this.$refs['priceTable'];
                if(priceTableRef){
                    checkPromise.push(priceTableRef.submitFormPromise('form'));
                }

                let priceTableInputRef = this.$refs['priceTableInput'];
                if(priceTableInputRef){
                    checkPromise.push(priceTableInputRef.submitFormPromise('form'));
                }

                return Promise.all(checkPromise).then(data=>{
                    return data;
                })
                    .catch(e => {
                        console.log(e);
                        return e;
                        // reject(e);
                    });
            },
            submitFormFnc(formName){
                let that = this;
                var f = function (){
                    const p = new Promise((resolve, reject) => {
                        let form = that.$refs[formName];
                        if(Array.isArray(that.$refs[formName])){
                            form = that.$refs[formName][0]
                        }
                        form.validate((valid) => {
                            if(valid){
                                resolve(true);
                            } else {
                                reject('请完成必填信息的填写！');
                            }
                        });
                    });
                    return p;
                }
                return f;
            },
            // 保存
            save(saveFlag, fn){
                    // console.log(this.choosedPriceList)
                    console.log(this.addedPriceList)
                    let that = this;

                    let priceTableRef = this.$refs['priceTable'];
                    let priceTableInputRef = this.$refs['priceTableInput'];
                    console.log(priceTableRef,'priceTableRef')
                    console.log(priceTableInputRef,'priceTableInputRef')
                    this.choosedPriceList = this.choosedPriceList.map(item => {
                        delete item.id;
                        item.listType = 1;
                        if (saveFlag != 0) {
                            if (item.dealListStatus == 2) {
                                item.dealListStatus = 3
                                // item.dealListRemarks = ''
                            }
                        } else {
                            if (item.dealListStatus == 1) {
                                item.dealListStatus = item.dealListStatus
                            }
                        }

                        if(item.quotationType == 1) {
                            item.amountExclTax = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                            item.amountWithTax = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                        }
                        return item;

                    })

                    this.addedPriceList = this.addedPriceList.map(item => {
                        item.listType = 2;
                        if (saveFlag != 0) {
                            if (item.dealListStatus == 2) {
                                item.dealListStatus = 3
                                // item.dealListRemarks = ''
                            }
                        } else {
                            if (item.dealListStatus == 1) {
                                item.dealListStatus = item.dealListStatus
                            }
                        }
                        if(item.quotationType == 1) {
                            // item.unitAmountExclTax = this.$root.accMul(this.$root.accDiv(item.unitAmountWithTax, this.$root.accAdd(this.$root.accDiv(item.taxRatio, 100),1)), item.quantities)
                            item.amountExclTax = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                            item.amountWithTax = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                        }
                        return item;
                    })
                    // if (saveFlag == 0) {
                    //     this.choosedPriceList.map(item => {
                    //         this.$set(item,'dealListStatus', '')
                    //     })
                    // }

                    let formParams = {
                        storeDetails: this.choosedPriceList,
                        newDetails: this.addedPriceList,
                        outMapAttachmentVOs: {},
                        backAttachmentVOS: this.returnAttachment,
                        remarks: this.remark,
                        saveFlag: saveFlag,
                        type: this.type,
                        extSProjectNotice: this.dispatchData,
                        id: this.orderId
                    };
                    for(let key in this.outMapAttachmentVOs){
                        formParams.outMapAttachmentVOs[key] = this.outMapAttachmentVOs[key].fileList;
                    }
                    // console.log(formParams)
                    // 驳回之后重新上传赋值只是当前的文件
                    // formParams.outMapAttachmentVOs ={}
                    // // console.log(this.outMapAttachmentVOs)
                    // for (let key in this.outMapAttachmentVOs) {
                    //     console.log(key)
                    //     formParams.outMapAttachmentVOs[key] = this.outMapAttachmentVOs[key].fileList;
                    // }
                    let contractRef = this.$refs['contract'];
                    // console.log('合同123',contractRef)
                    if (contractRef) {
                         if(contractRef.contract){
                            formParams.contractId = contractRef.contract.id;
                            formParams.companyId = contractRef.contract.companyId
                        }
                            // formParams.contractId = null
                            // formParams.companyId = null
                    } else {
                        formParams.contractId = null
                        formParams.companyId = null
                    }

                    // formParams.contractId = null
                    // formParams.companyId = null
                    let orderRef = this.$refs['order']
                    // console.log(orderRef,'12345')
                    if(orderRef){
                        formParams = Object.assign({}, orderRef.order,formParams);
                        formParams.saveFlag = saveFlag;
                    }
                    this.dispatchData.rebuildArea = orderRef.order.rebuildArea
                    formParams.categoryId = this.categoryId

                    this.$root.postHttp('/v1/outerformflowHS/approveContractForJS',formParams,function(res){
                        that.$alert(saveFlag == 1 ? '提交成功' : '保存成功', '提示', {
                            confirmButtonText: '确定',
                            type: 'success',
                            callback: action => {
                                window.close();
                                fn(true)
                            }
                        });
                    },function(){
                        fn(false);
                    })

            },
            launch(){
                let that = this
                this.checkForm().then((res)=>{
                    if(Array.isArray(res)){
                        // if(this.choosedPriceList.length == 0){
                        //     this.$alert('请先选择价格库清单',{
                        //         type: 'warning'
                        //     });
                        //     return;
                        // }
                        this.save(1, (result)=>{
                            if(result){
                            }
                        });
                    }else {
                        this.$alert(res,{
                            type: 'warning'
                        });
                    }
                }).catch(e=>{
                    // console.log(e);
                });
            },
            edit(data){
                // console.log(this.$refs['contract'],'合同123')

                // if (this.$refs['contract']) {
                    let contractRef = this.$refs['contract']
                    // if (contractRef){},
                //      if (contractRef.contract) {
                //         this.companyId = contractRef.contract.companyId
                //     } else {
                //     this.companyId = null
                //     }
                // } else {
                //     this.companyId = null
                // }
                // console.log(contractRef,'合同123')

                // if (contractRef.contract.companyId) {

                // console.log(this.choosedPriceList)
                if (this.choosedPriceList.length) {
                    this.$refs.priceChooseDialog.multipleSelection = this.choosedPriceList.map(item => {
                        item.quantities = item.quantities;
                        return item;
                    })
                }
                this.$refs.priceChooseDialog.show(this.category,this.companyId, null,this.orderStatusType,data)


                // } else {
                //     this.$alert('请先选择合同信息',{
                //         type: 'warning'
                //     });
                // }


            },
            ///提交验收申请
            submitSettle(){

                // console.log('5555555',this.attachments)
                let formParams = {
                    storeDetails: this.choosedPriceList,
                    newDetails: this.addedPriceList,
                    attachmentVOS: [],
                    remarks: this.remark,
                    saveFlag: 1,
                    submitType:2,
                    id: this.id
                };
                for(let key in this.outMapAttachmentVOs){
                        formParams.attachmentVOS = this.outMapAttachmentVOs.fileList;
                    }
                let error = 0;
                if(this.type == 5 && this.sourceType == 2){
                    error =  this.addedPriceList.filter(item=>{
                        return !item.actualQuantities || item.actualQuantities == 0
                    }).length
                    error +=  this.choosedPriceList.filter(item=>{
                        return !item.actualQuantities || item.actualQuantities == 0
                    }).length
                }else{
                    error =  this.addedPriceList.filter(item=>{
                        return !item.quantities && item.quantities !== 0
                    }).length
                    error +=  this.choosedPriceList.filter(item=>{
                        return !item.quantities && item.quantities !== 0
                    }).length
                }
                // console.log(error,'error123')
                // console.log(this.type,'type')
                if(error > 0){
                    this.$alert("请检查清单数量",{
                        type:'warning'
                    })
                    return
                }
                let contractRef = this.$refs['contract'];
                if(contractRef){
                    formParams.contractId = contractRef.contract ? contractRef.contract.id : '';
                }

                let orderRef = this.$refs['order'];
                if(orderRef){
                    formParams = Object.assign({}, orderRef.order,formParams);
                    formParams.saveFlag = 1;
                }

                let that =this
                this.$root.postFunc('/v1/outerformflowHS/approveOrderSettle',formParams,function(res){
                    that.$alert('提交成功', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            window.location.reload();
                            window.close();
                        }
                    });
                }
                ,function(){
                    // fn(false);
                })
            }
        }
    }
</script>

<style lang='scss' scoped>
    //@import url(); 引入公共css类

    @import '../../assets/_var.scss';
    @import "../../assets/iconfont/iconfont.css";
    .main-wrap {
        width: 100%;
    }
    .main-containers {
        margin: 0 auto;
        width: 80%;
        // width: 1100px;
        text-align: left;
    }
    .container /deep/{
        // margin-top: 60px;
        // padding-bottom: 15px;
        background-color: #ffffff;

        .el-table .cell{
            line-height: 15px;
        }

        .el-message-box {
            width: 500px;
        }

        .text-button.el-button {
            font-size: 16px;
            text-align: left;
            color: #333333;
            line-height: 21px;
            background: white;
            border: none;
        }

        .f14 {
            font-size: 14px!important;
        }

        & .unit {
            width: 100px;
            margin-right: 5px;
        }

        & .tip {
            margin-left: 10px;
            color: $--primary-color;
            font-size: 12px;
        }

        & .add {
            float: right;
            font-size: 14px;
            cursor: pointer;
            & img {
                vertical-align: middle;
                width: 70px;
                height: 26px;
            }
        }
        & .dele {
            position: absolute;
            top: 0px;
            right: 10px;
        }
        & .dele img {
            transform: scale(1);
            transition: .5s;
            width: 34px;
            height: 34px;
        }
        .dele:hover img {
            transform: scale(1.1);
        }
        & .remarks {
            width: 95%;
        }

        & .naturalForm  {
            padding: 20px 10px 5px;
            padding-left: 0px;
            padding-right: 26px;
            border: 1px solid #dcdfe6;
            border-radius: 3px;
            margin-bottom: 20px;
        }

        & h4{
            padding: 0 30px;
            text-align: left;
            line-height: 50px;
            color: $--text-color-light;
            background: $--secondary-fill-color;
            overflow: hidden;
            position: relative;

        }
        & h4 {
            text-indent: 10px;
            line-height: 35px;
            background: $--primary-fill-color;
        }

        .attachmentForm {
            .el-form-item__content {
                // width: 250px;
            }
        }

        .el-input__inner {
            border: none;
            border-bottom: 1px solid #C4C4C4;
            border-radius: 0px;
        }

        .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
            background-color: white;
            cursor: default;
        }

        .maxWidthForm {
            width: 100%;
            .el-form-item__content {
                width: calc(100% - 260px);
            }
        }

        .onlySupplier {
            .file-list .file-name {
                max-width: 190px!important;
            }
        }

        // .el-form-item {
        //     width: 100%;
        // }

        .el-form-item__error {
            width: 300px;
            padding: 0;
        }

        .el-form-item__label, .el-form-item__content{
            line-height: 30px;
        }

        .tag {
            .el-button {
                border-bottom-left-radius: 0px;
                border-bottom-right-radius: 0px;
            }
        }
    }
    .box-card{
        margin-bottom: 15px;
    }
    .minWidth{
        width: 250px;
    }
    h3{
        // background-color: #ececec;
        padding: 0 20px 5px;
        margin: 0;
        // margin-top: 10px;
        position: relative;
        cursor: pointer;
        padding-left: 25px;
    }

    .iconxiala::before {
        position: absolute;
        left: 0px;
        font-size: 20px;
    }

    .colorLine {
        margin-top: 10px;
        margin-bottom: 20px;
        padding-left: 20px;
    }

    h2 {
        font-size: 13px;
        margin-left: 20px;
    }
    .noMarginBottom{
        // margin-bottom: 0!important;
        margin-bottom: 10px!important;
        .tipWrap {
            position: relative;
            min-width: 250px;
            .tips {
                position: absolute;
                top: 16px;
                left: 100px;
                padding-left: 20px;
                font-size: 12px;
                color: $--text-color-light;
                /*background: url('../../assets/img/detail/tip.png') no-repeat left center;*/
            }
        }
    }

    .cf:before,.cf:after {
        content:"";
        display:table;
    }
    .cf:after { clear:both; }
    .marg-top-cls{
        margin-bottom: 20px;
    }
    /deep/ .el-form-item__content {
        font-size:14px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/settle.vue